import { Avatar, Flex, Image, Text } from "@fluentui/react-northstar";
import moment from "moment";
import React from "react";
import styled from "styled-components";

export default function ContentTimeLineCollegueInfo({ data }) {
    const textDependStatus = (statusId) => {
        let data = {
            content: "",
            background: "#fff",
            color: "#000",
        };
        switch (statusId) {
            case 1: {
                data = {
                    content: "En attente de validation",
                    background: "#FBF6D9",
                    border: "#EDC2A7",
                    color: "#CC4A31",
                };
                break;
            }
            case 2:
            case 3: {
                data = {
                    content: "Validée",
                    border: "#BDDA9B",
                    background: "#E7F2DA",
                    color: "#13A10E",
                };
                break;
            }
            default:
                data;
        }
        return data;
    };

    const status = textDependStatus(data?.status?.id);

    return (
        <Flex gap="gap.medium" column fill>
            <Flex fill space="between">
                <Flex column gap="gap.small">
                    <Label content="Absence pour" />
                    <Flex gap="gap.small" vAlign="center">
                        {data?.user?.avatar ? (
                            <Image
                                circular
                                avatar
                                name={data?.user?.name}
                                src={data?.user?.avatar}
                                styles={{ width: "40px", height: "40px" }}
                            />
                        ) : (
                            <Avatar name={data?.user?.name} size="smallest" />
                        )}
                        <CollegueName content={data?.user?.name} />
                    </Flex>
                </Flex>
                <EventStatus
                    borderColor={status.border}
                    background={status.background}
                >
                    {/* <StatusText content="En attente de validation" /> */}
                    <StatusText color={status.color} content={status.content} />
                    {data?.approval_date && (
                        <StatusText
                            color={status.color}
                            content={`le ${moment(data?.approval_date).format(
                                "DD/MM/YYYY"
                            )}`}
                        />
                    )}
                </EventStatus>
            </Flex>
            <Flex column gap="gap.small">
                <Label content="Date" />
                <DateFlex gap="gap.small" vAlign="center">
                    <Text
                        content={moment(data?.start_date).format("DD/MM/YYYY")}
                    />
                    <Text content=" - " />
                    <Text
                        content={moment(data?.end_date).format("DD/MM/YYYY")}
                    />
                </DateFlex>
            </Flex>
            <TypeEvent
                $bgColor={data.type.color}
                gap="gap.small"
                vAlign="center"
            >
                <Text content={data?.type?.name} />
                <Badge>
                    <Text content={data?.balance_count_to_remove} />
                </Badge>
            </TypeEvent>
        </Flex>
    );
}

const Label = styled(Text)`
    color: #686868;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
`;

const CollegueName = styled(Text)`
    color: #424242;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;

const EventStatus = styled(Flex)`
    height: 24px;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    width: 160px;
    gap: 4px;
    border-radius: 4px;
    border: 1px solid ${({ borderColor }) => borderColor};
    background: ${({ background }) => background};
`;

const StatusText = styled(Text)`
    color: ${({ color }) => color};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
`;
const DateFlex = styled(Flex)`
    border-radius: 4px;
    background: #e8ebfa;
    width: fit-content;
    padding: 4px 8px;
`;
const TypeEvent = styled(Flex)`
    border-radius: 6px;
    background-color: ${({ $bgColor }) => $bgColor};
    padding: 4px 8px;
    width: fit-content;
`;

const Badge = styled(Flex)`
    border-radius: 100px;
    background: rgba(41, 40, 40, 0.9);
    color: white;
    padding: 2px 8px;
`;
